import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  position: relative;
  align-items: center;
  color: white;
  flex: 1;
  @media screen and ${Device.mobileL} {
    font-size: 14px;
  }

  .ecrp-bonus-content {
    background-color: #28abf8;
    padding-top: 10px;
  }
  h4 {
    color: #002a44;
  }

  .slick-list {
    width: 100%;
    margin: 0 auto;
    img {
      width: 100%;
      max-width: 160px;
      margin: 0 auto;
      max-height: 160px;
      min-height: 156px;
    }
  }
  .slick-arrow {
    width: 8%;
    top: 43% !important;
    &.slick-prev {
      left: 8%;
    }
    &.slick-next {
      right: 8%;
    }
  }
  .bonus-item-desc {
    font-size: 14px;
    line-height: 15px;
    margin-bottom: 0;
  }
  .ecrp-bonus-notice {
    padding: 2%;
    margin: 0;
  }
`;
